import React from 'react'
import PendingChart from '../../../components/PendingChart'

const PendingProjectsIgr = ({ t, singleCard }) => {
    return (
        <div className="pending">
            <div className="c-pending" style={{flex: 1}}>
                <PendingChart title={t('one_pager_report.pending_legal_validity')} value={singleCard?.pendingLegalValidity} />
            </div>
        </div>
    )
}

export default PendingProjectsIgr